export const standardEmail = "suporte@2mpayments.com";
